import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";
import "firebase/auth";
import { initFirestorter, Collection, Document } from "firestorter";
import authStore from './authStore'

firebase.initializeApp({
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
    appId:process.env.REACT_APP_ID
});



initFirestorter({ firebase: firebase });

const locations = new Collection("locations")
const reports = new Collection("reports");
const users = new Collection("users");

const timestamp = firebase.firestore.FieldValue.serverTimestamp
const auth = firebase.auth()
const analytics  =firebase.analytics();

async function verifyLocation(location, score, userId, photoURL, displayName) {
    return new Promise(async (resolve, reject) => {
        if (location.isNew) {
            console.log("*** adding location ***", location)
            const doc = await locations.add({
                name: location.name,
                latlng: new firebase.firestore.GeoPoint(location.location.latitude, location.location.longitude),
                currentScore: score,
                lastReport: {
                    score: score,
                    createdOn: timestamp(),
                    user: {
                        id: userId,
                        photoURL: photoURL,
                        displayName: displayName
                    }

                }
            })

            resolve(doc)
        }
        else {
            const document = new Document(`locations/${location.id}`)
            await document.update({
                currentScore: score,
                lastReport: {
                    score: score,
                    createdOn: timestamp(),
                    user: {
                        id: userId,
                        photoURL: photoURL,
                        displayName: displayName
                    }
                }
            })

            resolve(document)
        }
    })

}
export async function adjustReport(score, location) {
    const document = new Document(`locations/${location.id}`)
    await document.update({
        currentScore: score
    })

    analytics.logEvent(`report_adjusted`,{location:location, score: score});
}

export async function addReport(score, reporterScore, location) {
    const locationDoc = await verifyLocation(location, score, auth.currentUser.uid, auth.currentUser.photoURL, auth.currentUser.displayName)

    const newReportDoc = await reports.add({
        createdOn: timestamp(),
        score: score,
        location: location.name,
        location_id: locationDoc.id,
        user_id: auth.currentUser.uid,
        userPhotoURL: auth.currentUser.photoURL
    });

    locationDoc.update({ 'lastReport.id': newReportDoc.id })

    addScoreToUser(auth.currentUser.uid, reporterScore)
}

async function addScoreToUser(uid, reporterScore) {
    const document = new Document(`users/${uid}`)
    const userDocRef = await document.ref.get()

    const newScore = (userDocRef.data().score || 0) + reporterScore

    document.set({
        score: newScore
    }, { merge: true })
}

export async function getUserDocumentRef(uid) {
    const document = new Document(`users/${uid}`)
    const userDocRef = await document.ref.get()
    return userDocRef
}

export async function getUser(uid) {
    const document = new Document(`users/${uid}`)
    const userDocRef = await document.ref.get()
    let userObj = {}
    if (userDocRef.exists) {
        userObj = {
            score: userDocRef.data().score,
            photoURL: userDocRef.data().photoURL,
            displayName: userDocRef.data().displayName,
            hearted: userDocRef.data().hearted,
            email: userDocRef.data().email,
            admin: userDocRef.data().admin
        }
    }

    return userObj
}

export async function markUserAsDeleted(user_id){
    return new Promise(async (resolve, reject) => {
        // // Mark location as deleted
        // const locationDocument = new Document(`locations/${location_id}`)
        // await locationDocument.update({ deleted: true })
        
        // // Mark all Reports for location as deleted
        // // Grab all reports
        // const locationReports = await new Collection('reports').ref.where('location_id', '==', location_id).get()
        // locationReports.forEach(async (report) => {
        //     await report.ref.update({ deleted: true })
        // })

        resolve()
    })
}

export async function markLocationAsDeleted(location_id) {
    return new Promise(async (resolve, reject) => {
        // Mark location as deleted
        const locationDocument = new Document(`locations/${location_id}`)
        await locationDocument.update({ deleted: true })
        
        // Mark all Reports for location as deleted
        // Grab all reports
        const locationReports = await new Collection('reports').ref.where('location_id', '==', location_id).get()
        locationReports.forEach(async (report) => {
            await report.ref.update({ deleted: true })
        })

        resolve()
    })
}

export async function favoriteReportById(reportDocumentId){
    const document = await new Document(`reports/${reportDocumentId}`).ref.get()
    await favoriteReport(document)
}

export async function favoriteReport(reportDocument) {
    const localUserObj = authStore.user.get()
    if (!localUserObj) {
        return false
    }

    const lastReportId = reportDocument.id
    const reportUserId = reportDocument.data().user_id
    const reportHearts = +reportDocument.data().hearts || 0

    if (localUserObj.uid === reportUserId) {
        return
    }
    // TODO: update the user profile for this like (that the current user has "hearted" this report)

    const userDocument = new Document(`users/${auth.currentUser.uid}`)

    const hearted = localUserObj.hearted || []
    if (hearted.indexOf(lastReportId) === -1) {
        hearted.indexOf(lastReportId)
        hearted.push(lastReportId)
        userDocument.set({
            hearted: hearted
        }, { merge: true })

        reportDocument.ref.set({
            hearts: reportHearts + 1
        }, { merge: true })
        analytics.logEvent(`favorite_report`,{report_id:lastReportId});
    }
    else {
        hearted.splice(hearted.indexOf(lastReportId), 1)
        userDocument.set({
            hearted: hearted
        }, { merge: true })

        if (reportHearts) {
            reportDocument.ref.set({
                hearts: reportHearts - 1
            }, { merge: true })
        }
        analytics.logEvent(`unfavorite_report`,{report_id:lastReportId});
    }
}

export async function updateUser(uid, params, force) {
    const document = new Document(`users/${uid}`)
    const userDocRef = await document.ref.get()
    if (userDocRef.exists) {
        let updateParams = {
            lastLogin: timestamp()
        }

        if (force) {
            updateParams = Object.assign(updateParams, params)
        }

        await document.set(updateParams, { merge: true })
    }
    else {
        analytics.logEvent(`sign_up`,{email:params.email});
        await document.set({
            createdOn: timestamp(),
            displayName: params.displayName,
            email: params.email,
            photoURL: params.photoURL,
            lastLogin: timestamp()
        }, { merge: true })
    }
}

export { users, locations, reports, auth, timestamp };